import { render, staticRenderFns } from "./WorldAddLink.vue?vue&type=template&id=26ec68a6&scoped=true&"
import script from "./WorldAddLink.vue?vue&type=script&lang=js&"
export * from "./WorldAddLink.vue?vue&type=script&lang=js&"
import style0 from "./WorldAddLink.vue?vue&type=style&index=0&id=26ec68a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../contacts/spa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ec68a6",
  null
  
)

export default component.exports